import { UseCase } from '../types';
import Icon from '../../../components/AppIcon';

interface UseCaseGridProps {
  useCases: UseCase[];
}

const UseCaseGrid = ({ useCases }: UseCaseGridProps) => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Key Use Cases
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Discover how our AI-powered analytics transform operations across multiple scenarios
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.map((useCase) => (
            <div
              key={useCase.id}
              className="bg-card rounded-xl p-6 border border-border hover:shadow-brand-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Icon name={useCase.icon} size={24} className="text-primary" />
              </div>
              
              <h3 className="text-xl font-bold text-foreground mb-3">
                {useCase.title}
              </h3>
              
              <p className="text-text-secondary mb-4 leading-relaxed">
                {useCase.description}
              </p>
              
              <ul className="space-y-2">
                {useCase.features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <Icon name="ChevronRight" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-foreground">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCaseGrid;